<template>
    <label class="cool-checkbox-2" tabindex="0">
        <slot></slot>
        <slot name="label"></slot>
    </label>
</template>

<style scoped lang="scss">
.cool-checkbox-2 {
    :deep(input[type="checkbox"]) {
        appearance: none;
        cursor: pointer;
        position: relative;
        width: 20px;
        height: 20px;
        border: 1px solid gray;
        /* Adjusts the position of the checkboxes on the text baseline */
        vertical-align: -0.485rem;
        /* Set here so that Windows' High-Contrast Mode can override */
        border: 1px solid #e6e5e6;
        border-radius: 2px;
        background-color: #ffffff;

        &::before {
            content: " ";
            width: 100%;
            height: 100%;
            background-image: url(./check.svg);
            background-size: 55%;
            background-repeat: no-repeat;
            background-position: center;
            position: absolute;
            font-size: 1.2em;
            visibility: hidden;
        }

        &:checked::before {
            /* Use `visibility` instead of `display` to avoid recalculating layout */
            visibility: visible;
        }

        &:disabled {
            border-color: black;
            background: #ddd;
            color: gray;
        }
    }
}
</style>

<script>
export default {
    name: "cool-checkbox-2",
};
</script>
